import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { connectionRequests } from "@/react/helpers/urlHelpers/internalApi/connectionRequests";

export interface ConnectionRequestInitiator {
  admin: boolean;
  avatar_url: string;
  headline?: string;
  id: number;
  location?: string;
  mutual_connections_count?: number;
  name: string;
  profile_confirmed_at?: string;
  public_uid: string;
  sqid: string;
  user_id: number;
}

export interface ConnectionRequest {
  created_at: string;
  id: number;
  initiator: ConnectionRequestInitiator;
  note?: string;
  status: string;
}

export interface GetConnectionRequestsResponse {
  count: number;
  has_next_page: boolean;
  page: number;
  page_count: number;
  per_page: number;
  records: ConnectionRequest[];
}

export const connectionRequestsApi = {
  getRequests: (params: { page: number; per_page: number }) =>
    reactQueryGet<GetConnectionRequestsResponse>(
      connectionRequests.index(params),
    ),
};
